import { NotificationSettings } from 'features/notification/notificationsSettings/ui/NotificationSettings'

export const NotificationsSettingsPage = () => {
    return (
        <NotificationSettings />
    )
}